var map = {
	"./aparthotelclub/ic_worldwide.png": 71037,
	"./beachful/ic_worldwide.png": 19999,
	"./castlepedia/ic_worldwide.png": 55361,
	"./cocktayl/ic_worldwide.png": 44029,
	"./ic_worldwide.png": 44282,
	"./luxresortclub/ic_worldwide.png": 13338,
	"./parkful/ic_worldwide.png": 60066,
	"./prefabworld/ic_worldwide.png": 85281,
	"./rooftopclub/ic_worldwide.png": 33457,
	"./spaclub/ic_worldwide.png": 96171,
	"./worldcasino/ic_worldwide.png": 10260,
	"./zoopedia/ic_worldwide.png": 34748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84496;